var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoInformationRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#F2FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6022 52.8486H63.7386C62.3321 52.8486 60.9833 53.4073 59.9888 54.4019C58.9943 55.3964 58.4355 56.7452 58.4355 58.1517V100.576C58.4355 101.982 58.9943 103.331 59.9888 104.326C60.9833 105.32 62.3321 105.879 63.7386 105.879H95.5568C96.9632 105.879 98.3121 105.32 99.3066 104.326C100.301 103.331 100.86 101.982 100.86 100.576V66.1062L87.6022 52.8486Z",
    fill: "#CAF0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1784 45.4238H56.3147C54.9083 45.4238 53.5595 45.9825 52.5649 46.977C51.5704 47.9716 51.0117 49.3204 51.0117 50.7269V93.1511C51.0117 94.5576 51.5704 95.9064 52.5649 96.9009C53.5595 97.8954 54.9083 98.4541 56.3147 98.4541H88.1329C89.5394 98.4541 90.8882 97.8954 91.8827 96.9009C92.8773 95.9064 93.436 94.5576 93.436 93.1511V58.6814L80.1784 45.4238Z",
    fill: "#ADE8F4",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5273 45.4238V56.0299C77.5273 57.4363 78.0861 58.7852 79.0806 59.7797C80.0751 60.7742 81.4239 61.3329 82.8304 61.3329H93.4364",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85C80 83.1435 79.1571 81.363 77.6569 80.0503C76.1566 78.7375 74.1217 78 72 78C69.8783 78 67.8434 78.7375 66.3431 80.0503C64.8429 81.363 64 83.1435 64 85",
    stroke: "#0096C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 78C75.5376 78 78 75.5376 78 72.5C78 69.4624 75.5376 67 72.5 67C69.4624 67 67 69.4624 67 72.5C67 75.5376 69.4624 78 72.5 78Z",
    stroke: "#0096C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0332 49.7689V60.0676L70.2078 38.3477L42.0332 49.7689Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0337 49.7737L70.8544 38L31.5 42.079L42.0337 49.7737Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4199 51.9078L58.9883 61.9455L70.8534 38L45.4199 51.9078Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4204 51.9043L42.0332 60.0689L49.2514 54.7368L45.4204 51.9043Z",
    fill: "white",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0723 59.6354C42.2746 59.5506 42.4704 59.4592 42.6662 59.3613L42.0723 59.6354Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0723 59.6354C42.2746 59.5506 42.4704 59.4592 42.6662 59.3613",
    stroke: "#0096C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInformationRequest);
export default __webpack_public_path__ + "static/media/NoInformationRequest.eca4e8a47bb08ae072c7c60718db69b2.svg";
export { ForwardRef as ReactComponent };